'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { FC, Suspense, useEffect, useState } from 'react';

import { CrossButton } from '@/components/Headers/SecondaryHeader/CrossButton';
import { SecondaryHeaderProps } from '@/components/Headers/SecondaryHeader/SecondaryHeader.types';
import { LeftArrowIcon, LogoIcon } from '@/components/ui/Icons/Icons';
import { ROUTES } from '@/constants/common';
import { checkLocalRouting } from '@/utils/helpers/checkLockRouting';

import * as S from './SecondaryHeader.styles';

export const SecondaryHeader: FC<SecondaryHeaderProps> = ({
  withCloseBtn = false,
  withBackButton = false
}) => {
  const router = useRouter();
  const [isLocalRouting, setIsLocalRouting] = useState(false);

  useEffect(() => {
    setIsLocalRouting(checkLocalRouting());
  }, []);

  const handleBack = () => {
    if (isLocalRouting) return router.back();
  };

  const isVisibleBackButton = isLocalRouting && withBackButton;

  return (
    <S.Header
      $isVisibleButton={isLocalRouting}
      $withBackButton={withBackButton}
      $withCloseBtn={withCloseBtn}
    >
      {isVisibleBackButton && (
        <S.BackButton onClick={handleBack}>
          <LeftArrowIcon />
        </S.BackButton>
      )}

      <Link href={ROUTES.HOME} data-id="header-logo">
        <LogoIcon />
      </Link>
      {withCloseBtn && (
        <Suspense>
          <CrossButton />
        </Suspense>
      )}
    </S.Header>
  );
};
